/* Ported from ac-cat-v2 assets/pdp-buy.js. */
/* Atlas PDP: variant selection (colour / size / bundle pieces), price + availability, complete-the-kit add-ons,
   free-shipping progress, add to cart, sticky bar (minimise / restore), details accordion and modals. */
(function () {
  const A = () => window.Atlas || {};
  const money = (c) => (A().money ? A().money(c) : '$' + (c / 100));

  function init(root) {
    if (root.__pdpBuy) return;
    root.__pdpBuy = true;

    const data = JSON.parse(root.querySelector('[data-pdp-json]').textContent);
    const ds = root.dataset;
    const L = { atc: ds.lAtc || 'Add to cart', sold: ds.lSold || 'Sold out', add: ds.lAdd || 'Add', save: ds.lSave || 'Save', size: ds.lSize || 'Select a size', sizes: ds.lSizes || 'Select sizes' };
    const bundle = root.dataset.bundle === 'true';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* free shipping amount for the shopper's market (Theme settings > Free shipping): 0 is always free. With no amount
       in the cart's currency, the default amount (shop currency) is converted at Shopify's rate, else the bar hides. */
    let thr = parseInt(root.dataset.thr, 10);
    if (root.dataset.thrBase) {
      const sc = window.Shopify && window.Shopify.currency;
      if (sc && sc.rate && sc.active === root.dataset.thrCur) {
        thr = Math.ceil((parseInt(root.dataset.thrBase, 10) / 100) * parseFloat(sc.rate)) * 100;
        const ship = root.querySelector('[data-pdp-ship]'); if (ship) ship.hidden = false;
      }
    }
    if (isNaN(thr)) thr = -1;
    const piecesSum = parseInt(root.dataset.piecesSum, 10) || 0;
    const byId = (id) => data.variants.find((v) => v.id === id);
    /* a variant the cart refused as sold out (stock only at a location that can't ship here) greys out */
    document.addEventListener('atlas:soldout', (e) => {
      let hit = false;
      data.variants.forEach((v) => { if (v.a && e.detail.ids.indexOf(v.id) > -1) { v.a = false; hit = true; } });
      if (hit && typeof update === 'function') update();
    });

    const st = { color: root.dataset.startColor || null, size: root.dataset.startSize || null, sel: {}, bErr: false, sizeErr: false };
    if (bundle && data.selected) {
      const sv = byId(data.selected);
      if (sv) data.options.forEach((_, k) => { st.sel[k] = sv.o[k]; });
    }

    // single-value options (e.g. "One size") are selected automatically
    if (!bundle && data.sizePos >= 0 && !st.size) {
      const vals = [...new Set(data.variants.map((v) => v.o[data.sizePos]))];
      if (vals.length === 1) st.size = vals[0];
    }
    if (bundle) {
      data.options.forEach((_, k) => {
        const vals = [...new Set(data.variants.map((v) => v.o[k]))];
        if (vals.length === 1 && !st.sel[k]) st.sel[k] = vals[0];
      });
    }

    const $ = (sel, el) => (el || root).querySelector(sel);
    const $$ = (sel, el) => [...(el || root).querySelectorAll(sel)];
    const out = (key, text) => $$('[data-out="' + key + '"]').forEach((el) => { el.textContent = text; });
    const show = (key, on) => $$('[data-out="' + key + '"]').forEach((el) => { el.hidden = !on; });

    /* ───── variant resolution ───── */
    function find(fn) { return data.variants.find((v) => v.a && fn(v.o)) || data.variants.find((v) => fn(v.o)) || null; }
    function resolved() {
      if (bundle) {
        if (!data.options.every((_, k) => st.sel[k])) return null;
        return find((o) => data.options.every((_, k) => o[k] === st.sel[k]));
      }
      if (data.sizePos >= 0 && !st.size) return null;
      return find((o) => (data.colorPos < 0 || o[data.colorPos] === st.color) && (data.sizePos < 0 || o[data.sizePos] === st.size));
    }
    function display() {
      const v = resolved();
      if (v) return v;
      if (!bundle && data.colorPos >= 0 && st.color) {
        const c = find((o) => o[data.colorPos] === st.color);
        if (c) return c;
      }
      return byId(data.current) || data.variants[0];
    }

    /* ───── add-ons ───── */
    const addons = $$('[data-addon]');
    const addOn = () => addons.filter((a) => a.classList.contains('is-on'));
    addons.forEach((a) => {
      const tog = () => { a.classList.toggle('is-on'); a.setAttribute('aria-pressed', a.classList.contains('is-on')); update(); };
      a.addEventListener('click', tog);
      a.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tog(); } });
    });

    /* ───── render ───── */
    function update() {
      const d = display();
      const v = resolved();
      const price = d.p;
      const addPrice = addOn().reduce((t, a) => t + (+a.dataset.price || 0), 0);
      const addCompare = addOn().reduce((t, a) => t + (+a.dataset.compare || 0), 0);
      const total = price + addPrice;

      out('price', money(price));
      const inst = root.dataset.installments;
      if (inst) out('inst', inst.replace('{amount}', money(Math.round(price / 4))));

      let full, hasSave, saveAmt;
      if (bundle) {
        const was = d.c > d.p ? d.c : piecesSum;
        saveAmt = Math.max(0, was - price);
        full = was;
        hasSave = saveAmt > 0;
        out('was', money(was)); show('was', hasSave);
        out('save', L.save + ' ' + money(saveAmt)); show('save', hasSave);
      } else {
        full = (d.c > d.p ? d.c : d.p) + addCompare;
        saveAmt = full - total;
        hasSave = saveAmt > 0;
      }
      out('total', money(total));
      out('atc-compare', money(full)); show('atc-compare', hasSave);
      out('atc-save', L.save + ' ' + money(saveAmt)); show('atc-save', hasSave);

      // colour / size / bundle option state
      $$('[data-color]').forEach((b) => b.classList.toggle('is-on', b.dataset.color === st.color));
      const cn = $('[data-color-name]');
      if (cn && st.color) cn.textContent = st.color;
      $$('[data-size]').forEach((b) => {
        const on = b.dataset.size === st.size;
        b.classList.toggle('is-on', on);
        const m = find((o) => (data.colorPos < 0 || o[data.colorPos] === st.color) && o[data.sizePos] === b.dataset.size);
        b.classList.toggle('is-oos', !!m && !m.a);
      });
      $$('[data-sheet-size]').forEach((b) => {
        const m = find((o) => (data.colorPos < 0 || o[data.colorPos] === st.color) && o[data.sizePos] === b.dataset.sheetSize);
        b.classList.toggle('is-oos', !!m && !m.a);
      });
      const sizeErr = $('[data-size-err]');
      if (sizeErr) sizeErr.hidden = !st.sizeErr || !!st.size;

      if (bundle) {
        $$('[data-bopt]').forEach((b) => {
          const k = +b.dataset.bopt;
          b.classList.toggle('is-on', st.sel[k] === b.dataset.val);
          // sold out when no available bundle variant has this size, given the sizes picked for the other pieces
          const m = find((o) => o[k] === b.dataset.val && data.options.every((_, j) => j === k || !st.sel[j] || o[j] === st.sel[j]));
          b.classList.toggle('is-oos', !m || !m.a);
        });
        $$('[data-piece]').forEach((c) => {
          const k = +c.dataset.k;
          const done = k < 0 || !!st.sel[k];
          c.classList.toggle('is-done', done);
          c.classList.toggle('is-err', st.bErr && !done);
        });
        const left = data.options.filter((_, k) => !st.sel[k]).length;
        const be = $('[data-bundle-err]');
        if (be) {
          be.hidden = !(st.bErr && left > 0);
          be.textContent = 'Select a size for ' + (left === 1 ? 'the last piece' : 'all ' + left + ' pieces') + ' to continue.';
        }
      }

      // free shipping progress
      if (thr >= 0) {
      const msg = thr === 0 ? (root.dataset.msgFree || root.dataset.msgDone) : total < thr ? root.dataset.msgAway.replace('{amount}', money(thr - total)) : root.dataset.msgDone;
      const sm = $('[data-ship-msg]'); if (sm) sm.textContent = msg;
      const sf = $('[data-ship-fill]'); if (sf) sf.style.width = (thr === 0 ? 100 : Math.min(100, (total / thr) * 100)) + '%';
      const tl = $('[data-tier-label="1"]'); if (tl && root.dataset.thrBase && root.dataset.tierText) tl.textContent = root.dataset.tierText.replace('{amount}', money(thr));
      [[1, thr]].forEach(([n, lim]) => {
        const dot = $('[data-tier="' + n + '"]'); if (!dot) return;
        const done = total >= lim;
        dot.classList.toggle('is-done', done);
        $('[data-d="done"]', dot).hidden = !done;
        $('[data-d="todo"]', dot).hidden = done;
      });
      }

      // buttons
      const soldOut = !!v && !v.a;
      $$('[data-atc="main"] [data-atc-label]').forEach((el) => { el.textContent = soldOut ? L.sold : L.atc; });
      $$('[data-atc-btn]').forEach((b) => { if (b.dataset.atc === 'main') b.disabled = soldOut; });
      const picked = bundle ? !!v : (data.sizePos < 0 || !!st.size);
      out('sticky-btn', soldOut ? L.sold : picked ? L.atc : (bundle ? L.sizes : L.size));
      const unit = root.dataset.unit;
      let sub;
      if (picked) {
        const parts = [];
        if (!bundle && st.color) parts.push(st.color);
        if (bundle) parts.push(data.options.map((_, k) => st.sel[k]).filter(Boolean).join(' / '));
        else if (st.size) parts.push(st.size);
        if (unit && !bundle) parts.push('1 ' + unit);
        sub = parts.join(' · ');
      } else {
        sub = money(price);
      }
      out('sticky-sub', sub);
      out('sticky-cta', soldOut ? L.sold : picked ? L.add + ' · ' + money(total) : (bundle ? L.sizes : L.size));
      const note = bundle ? (root.dataset.noteBundle || '').replace('{amount}', money(saveAmt))
        : (addOn().length ? root.dataset.noteAddons : root.dataset.noteDefault);
      out('bar-note', note || '');

      if (v) {
        const u = new URL(window.location.href);
        if (u.searchParams.get('variant') !== String(v.id)) {
          u.searchParams.set('variant', v.id);
          try { history.replaceState(null, '', u.toString()); } catch (e) { /* ignore */ }
        }
      }
    }

    function gotoMediaFor(d) {
      if (d && d.m) root.dispatchEvent(new CustomEvent('pdp:variant-media', { detail: { mediaId: d.m } }));
    }

    /* ───── option handlers ───── */
    $$('[data-color]').forEach((b) => b.addEventListener('click', () => {
      st.color = b.dataset.color;
      update();
      gotoMediaFor(display());
    }));
    $$('[data-size]').forEach((b) => b.addEventListener('click', () => {
      st.size = b.dataset.size; st.sizeErr = false;
      update();
      const v = resolved();
      if (v) gotoMediaFor(v);
    }));
    $$('[data-bopt]').forEach((b) => b.addEventListener('click', () => {
      st.sel[b.dataset.bopt] = b.dataset.val;
      st.bErr = false;
      update();
      const v = resolved();
      if (v) gotoMediaFor(v);
    }));

    /* ───── add to cart ───── */
    const mainBtn = $('[data-atc="main"]');
    const atcVisible = () => (mainBtn ? mainBtn.getBoundingClientRect().bottom > 0 : true);
    function scrollToAnchor() {
      const el = $('[data-size-anchor]');
      if (el) window.scrollTo({ top: window.scrollY + el.getBoundingClientRect().top - 120, behavior: reduce ? 'auto' : 'smooth' });
    }
    function addToCart() {
      const v = resolved();
      if (!v) {
        if (bundle) { st.bErr = true; update(); scrollToAnchor(); return; }
        if (!atcVisible() && A().isMobile && A().isMobile() && $('[data-modal="sheet"]')) { openModal('sheet'); return; }
        st.sizeErr = true; update(); scrollToAnchor();
        return;
      }
      if (!v.a) return;
      const items = [{ id: v.id, quantity: 1 }];
      addOn().forEach((a) => items.push({ id: +a.dataset.variant, quantity: 1 }));
      const btns = $$('[data-atc-btn]');
      const atcErr = $('[data-atc-err]');
      if (atcErr) atcErr.hidden = true;
      btns.forEach((b) => { b.disabled = true; });
      A().cart.add(items, { open: true }).then(() => {
        addons.forEach((a) => { a.classList.remove('is-on'); a.setAttribute('aria-pressed', 'false'); });
        closeModal('sheet');
        update();
      }).catch((err) => {
        /* show Shopify's reason (e.g. not enough stock) under the button, or a plain fallback */
        if (window.console) console.error('Add to cart failed', err);
        if (atcErr) {
          atcErr.textContent = (err && err.description) || 'Sorry, this couldn\'t be added to your cart. Please try again.';
          atcErr.hidden = false;
          if (mainBtn && !atcVisible()) mainBtn.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        }
      }).then(() => { btns.forEach((b) => { b.disabled = false; }); update(); });
    }
    $$('[data-atc-btn]').forEach((b) => b.addEventListener('click', addToCart));

    /* ───── sheet / chart / description modals ───── */
    const overlays = new Set();
    function syncOverlay() { root.dataset.overlay = overlays.size ? '1' : '0'; }
    root.addEventListener('pdp:overlay', (e) => { if (e.detail.open) overlays.add(e.detail.key); else overlays.delete(e.detail.key); syncOverlay(); });
    let modalFocus = null;
    function openModal(key) {
      const m = $('[data-modal="' + key + '"]'); if (!m) return;
      modalFocus = document.activeElement;
      m.hidden = false;
      if (key !== 'sheet') document.body.classList.add('atlas-lock');
      if (key.indexOf('chart') === 0 || key === 'sheet') { overlays.add(key); syncOverlay(); }
      const f = m.querySelector('[data-close],button'); if (f) f.focus();
    }
    function closeModal(key) {
      const m = $('[data-modal="' + key + '"]'); if (!m || m.hidden) return;
      m.hidden = true;
      overlays.delete(key); syncOverlay();
      if (!$$('[data-modal]').some((x) => !x.hidden && x.dataset.modal !== 'sheet')) document.body.classList.remove('atlas-lock');
      if (modalFocus && modalFocus.focus) modalFocus.focus();
    }
    $$('[data-open]').forEach((b) => b.addEventListener('click', () => openModal(b.dataset.open)));
    $$('[data-modal]').forEach((m) => {
      m.addEventListener('click', (e) => { if (e.target === m) closeModal(m.dataset.modal); });
      $$('[data-close]', m).forEach((b) => b.addEventListener('click', () => closeModal(m.dataset.modal)));
    });
    $$('[data-sheet-size]').forEach((b) => b.addEventListener('click', () => {
      st.size = b.dataset.sheetSize; st.sizeErr = false;
      update(); gotoMediaFor(resolved());
      addToCart();
    }));
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = $$('[data-modal]').filter((m) => !m.hidden && (m.dataset.modal.indexOf('chart') === 0 || m.dataset.modal === 'desc'));
      if (open.length) { closeModal(open[0].dataset.modal); return; }
      const sh = $('[data-modal="sheet"]'); if (sh && !sh.hidden) closeModal('sheet');
    });

    /* ───── details accordion (one open at a time) ───── */
    $$('[data-acc]').forEach((acc) => {
      const btn = $('[data-acc-btn]', acc), panel = $('[data-acc-panel]', acc);
      btn.addEventListener('click', () => {
        const open = !acc.classList.contains('is-open');
        $$('[data-acc]').forEach((o) => {
          o.classList.remove('is-open');
          $('[data-acc-btn]', o).setAttribute('aria-expanded', 'false');
          $('[data-acc-panel]', o).hidden = true;
        });
        if (open) { acc.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
      });
    });

    /* ───── sticky bar: minimise / restore (GSAP in the prototype → Web Animations API) ───── */
    const pill = $('[data-pill]');
    const activeBar = () => $$('[data-bar]').find((b) => b.getClientRects().length > 0) || null;
    const store = (min) => { try { localStorage.setItem('atlas_atc_min', min ? '1' : '0'); } catch (e) { /* ignore */ } };
    let startMin = false;
    try { startMin = localStorage.getItem('atlas_atc_min') === '1'; } catch (e) { /* ignore */ }
    root.dataset.min = startMin ? '1' : '0';
    function minimize() {
      store(true);
      const bar = activeBar();
      if (reduce || !bar || !pill) { root.dataset.min = '1'; return; }
      const a = bar.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(24px) scale(0.94)' }], { duration: 320, easing: 'cubic-bezier(.55,.055,.675,.19)', fill: 'forwards' });
      setTimeout(() => {
        root.dataset.min = '1';
        a.cancel();
        pill.animate([{ opacity: 0, transform: 'translateY(14px) scale(0.7)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      }, 240);
    }
    function restore() {
      store(false);
      const bar = activeBar();
      if (reduce || !bar || !pill) { root.dataset.min = '0'; return; }
      const p = pill.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(10px) scale(0.8)' }], { duration: 200, easing: 'cubic-bezier(.55,.085,.68,.53)', fill: 'forwards' });
      setTimeout(() => {
        root.dataset.min = '0';
        p.cancel();
        bar.animate([{ opacity: 0, transform: 'translateY(28px) scale(0.94)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
      }, 160);
    }
    $$('[data-bar-min]').forEach((b) => b.addEventListener('click', minimize));
    if (pill) pill.addEventListener('click', restore);

    update();
  }

  function boot() { document.querySelectorAll('[data-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Complete the kit: quick add like the product cards. + (or hover on desktop) shows the sizes;
   a size, or + on a one size piece, adds that variant to the cart. */
(function () {
  if (window.__atlasKitq) return;
  window.__atlasKitq = true;
  const closeAll = (except) => document.querySelectorAll('[data-kitq].is-q').forEach((c) => { if (c !== except) c.classList.remove('is-q'); });
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-kitq-open]');
    if (open) {
      e.preventDefault();
      const card = open.closest('[data-kitq]');
      closeAll(card);
      card.classList.toggle('is-q');
      return;
    }
    const add = e.target.closest('[data-kitq-add]');
    if (add) {
      e.preventDefault();
      const card = add.closest('[data-kitq]');
      if (add.disabled || !card || card.classList.contains('is-busy') || !window.Atlas || !window.Atlas.cart) return;
      const kit = card.closest('.pdp-kit');
      const err = kit && kit.querySelector('[data-kitq-err]');
      if (err) err.hidden = true;
      card.classList.add('is-busy');
      add.classList.add('is-loading');
      window.Atlas.cart.add([{ id: Number(add.dataset.kitqAdd), quantity: 1 }], { open: true })
        .then(() => {
          card.classList.remove('is-q');
          card.classList.add('is-added');
          setTimeout(() => card.classList.remove('is-added'), 1800);
        })
        .catch((x) => {
          if (err) { err.textContent = (x && x.description) || 'Sorry, this couldn\'t be added to your cart. Please try again.'; err.hidden = false; }
        })
        .then(() => { card.classList.remove('is-busy'); add.classList.remove('is-loading'); });
      return;
    }
    if (!e.target.closest('[data-kitq]')) closeAll(null);
  });
})();

